import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import { CONSTANT_REDIRECT_TIME } from "../../../../constant/common";
import { toast } from "react-toastify";


const InquiryEmailSend = ({ isInquiryEmailSend, setIsInquiryEmailSend, practices_id, setSelectedPractice, goToHomeUrl }) => {

    const [isMailSend, setIsMailSend] = useState(false);

    const [formData, setFormData] = useState({
        fk_practices_id: null,
        name: "",
        email: "",
        phone: "",
        message: ""
    })

    useEffect(() => {
        if (isInquiryEmailSend) {
            setIsMailSend(false);
            setFormData({
                fk_practices_id: practices_id || null,
                name: "",
                email: "",
                phone: "",
                message: ""
            });
        }
    }, [isInquiryEmailSend]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await api.post("add-enquiries", formData);

            if (response?.data?.status === true) {
                // toast.success(response.data?.message);

                // setTimeout(() => {
                setIsMailSend(true)
                if (setSelectedPractice) {
                    setSelectedPractice(null)
                }
                // }, CONSTANT_REDIRECT_TIME);

            } else {
                toast.error(response?.data?.message || "Failed ");
                return null;
            }
        } catch (error) {
            console.error("Error :", error);
            toast.error("Something went wrong. Please try again.");
            return null;
        }
    }

    return (
        <>
            <div id="emailModal" class={`fixed z-[999] inset-0 items-center justify-center bg-black bg-opacity-50 px-3 ${isInquiryEmailSend === true ? 'flex' : 'hidden'}`}>
                <div className="emailbox bg-white p-9 rounded-lg shadow-lg w-full max-w-[512px] relative min-h-[60vh] max-h-[90vh]">
                    <button
                        onClick={() => {
                            setIsInquiryEmailSend(false)
                            if (setSelectedPractice) {
                                setSelectedPractice(null)
                            }
                        }}
                        type="button" className="absolute right-4 top-4"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.41791 0.436139C0.685579 0.168311 1.04857 0.0178675 1.42704 0.0178675C1.80551 0.0178675 2.1685 0.168311 2.43617 0.436139L9.99103 7.99754L17.5459 0.436139C17.6777 0.299682 17.8351 0.190853 18.0092 0.115982C18.1834 0.0411107 18.3708 0.00171073 18.5602 5.3593e-05C18.7497 -0.00158926 18.9377 0.0345535 19.1131 0.106382C19.2886 0.17821 19.4479 0.284296 19.5819 0.418424C19.7159 0.552553 19.822 0.712052 19.8938 0.887623C19.9654 1.06319 20.0015 1.25131 19.9999 1.44099C19.9982 1.63068 19.9588 1.81814 19.884 1.99242C19.8093 2.16671 19.7005 2.32435 19.5642 2.45612L12.0093 10.0175L19.5642 17.5789C19.8242 17.8484 19.9681 18.2092 19.9648 18.5838C19.9616 18.9584 19.8115 19.3167 19.5468 19.5815C19.2821 19.8464 18.9242 19.9967 18.5499 19.9999C18.1757 20.0032 17.8151 19.8592 17.5459 19.5989L9.99103 12.0375L2.43617 19.5989C2.16697 19.8592 1.80643 20.0032 1.43218 19.9999C1.05793 19.9967 0.699938 19.8464 0.435296 19.5815C0.170653 19.3167 0.0205397 18.9584 0.0172997 18.5838C0.0140454 18.2092 0.157906 17.8484 0.41791 17.5789L7.97277 10.0175L0.41791 2.45612C0.150327 2.18824 0 1.82494 0 1.44612C0 1.06732 0.150327 0.704024 0.41791 0.436139Z" fill="black"></path></svg></button>
                    <form onSubmit={handleSubmit} className={`space-y-3 ${isMailSend === true ? 'hidden' : ''}`} id="mailform">
                        <div>
                            <label for="name" className="mb-2 inline-block text-dark font-semibold text-base">Your name</label>
                            <input
                                value={formData.name}
                                onChange={handleChange} required type="text" name="name" id="name" className="border-[1.2px] border-dark w-full h-10 sm:h-12 rounded-xl px-3 sm:px-4 focus:border-blue outline-none text-lg" placeholder="Enter your name" />
                        </div>
                        <div>
                            <label for="email" className="mb-2 inline-block text-dark font-semibold text-base">Email</label>
                            <input
                                value={formData.email}
                                onChange={handleChange} required type="email" name="email" id="email" className="border-[1.2px] border-dark w-full h-10 sm:h-12 rounded-xl px-3 sm:px-4 focus:border-blue outline-none text-lg " placeholder="Enter your email" />
                        </div>
                        <div>
                            <label for="phone" className="mb-2 inline-block text-dark font-semibold text-base">Phone</label>
                            <input
                                value={formData.phone}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    if (value.length <= 10) {
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            phone: value,
                                        }));
                                    }
                                }}
                                required type="text" id="phone" name="phone" placeholder="Enter your phone number" className="border-[1.2px] border-dark w-full h-10 sm:h-12 rounded-xl px-3 sm:px-4 focus:border-blue outline-none text-lg " />
                        </div>
                        <div>
                            <label for="message" className="mb-2 inline-block text-dark font-semibold text-base">Message</label>
                            <textarea onChange={handleChange} value={formData.message} required id="message" name="message" placeholder="Description" className="border-[1.2px] border-dark w-full  rounded-xl px-3 sm:px-4 focus:border-blue outline-none text-lg  py-3 min-h-28 "></textarea>
                        </div>
                        <div className="flex items-start">
                            <input required id="default-checkbox" type="checkbox" value="" className="w-4 sm:w-5 h-4 sm:h-5 text-blue-600 bg-gray-100 border-gray-300 rounded  dark:bg-gray-700 dark:border-gray-600 mt-1" />
                            <label for="default-checkbox" className="ms-2 text-sm font-medium text-dark w-[calc(100%-20px)]">By submitting this form, I agree to the <Link to={'/terms-conditions'} target="_blank" className="text-blue font-semibold">Terms &amp; Conditions</Link>  &amp; <Link to={'/privacy-policy'} target="_blank" className="text-blue font-semibold">Privacy Policy</Link>, and I understand that I can opt out at any time.</label>
                        </div>
                        <button type="submit" className="h-auto py-3 px-3 sm:h-14 bg-blue w-full text-center text-white font-semibold text-lg sm:text-2xl rounded-xl mb-4 sm:mb-4">Send</button>
                    </form>
                    <div id="emailthankYouSection" className={`items-center justify-center flex-col ${isMailSend === true ? 'flex' : 'hidden'}`}>
                        <img src="/assets/image/svg/thankyou.svg" alt="" className="mb-8" />
                        <p className="text-[26px] leading-normal font-bold text-center text-blue mb-6">Thank you for your submission!</p>
                        <p className="text-xl font-semibold text-center text-blue mb-3">Your message has been successfully sent.</p>
                        <p className="text-xl font-light text-center text-dark mb-16">Our team will be in touch with you shortly</p>
                        <Link to={goToHomeUrl} className="px-11 py-3  bg-blue text-white rounded-[8px] font-bold border-2 border-solid border-blue hover:scale-[1.04] inline-block transition ease-in-out">Go to Home</Link>
                    </div>
                </div>
            </div>
        </>
    )
}
export default InquiryEmailSend;
